export default __webpack_public_path__ + "static/truck-59f6bf28adf1f6f94104e78208b2970f.png";